import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../api/api-response';
import { Dashboard } from './dashboard.model';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/Dashboard`;

  obter(inicio?: string, fim?: string): Observable<ApiResponse<Dashboard>> {
    let params: Record<string, string> = {};
    if (inicio) params['inicio'] = inicio;
    if (fim) params['fim'] = fim;
    return this.http.get<ApiResponse<Dashboard>>(this.url, { params });
  }
}
